module.exports = __webpack_public_path__ + "static/media/nele-kaufusi.894d4b6a.jpeg";